<footer>
    <div class="section bg-dark">
        <div class="container">
            <div class="row g-4 align-items-center">
                <div class="col-12 col-md-6 text-center text-md-start">
                    <h2 class="uppercase letter-spacing-1">Maximo</h2>
                    <ul class="list-inline-dash mt-3">
                        <li><a href="#">Terms and Conditions</a></li>
                        <li><a href="#">Careers</a></li>
                        <li><a href="#">Clients</a></li>
                    </ul>
                    <p class="mt-2">&copy; 2026 Maximo, All Rights Reserved.</p>
                </div>
                <div class="col-12 col-md-6 text-center text-md-end">
                    <ul class="list-unstyled">
                        <li>Patton Street Caulfield East VIC 3145</li>
                        <li>yoursite&#64;domain.com</li>
                    </ul>
                    <ul class="list-inline-sm mt-3 mt-lg-4">
                        <li *ngFor="let social of socialIcons">
                            <a class="button-circle button-circle-sm" [ngClass]="'button-circle-social-' + social.name" routerLink="/">
                                <i class="bi" [ngClass]="'bi-' + social.icon"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</footer>